import {
  LEAVE_ATTN,
  LEAVE_FOR_EMPLOYEE,
  ATTENDANCE_FOR_EMPLOYEE,
  EMPLOYEE_ATTENDANCE,
  EMPLOYEE_LEAVE,
  LEAVE_TYPE,
  COMP_OFF_FOR_EMPLOYEE,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

// Combined "Leave & Attn" top menu — the HR/admin apply-on-behalf screens for leave and
// attendance. (Self-service "My Leave" / "Attendance Request" / "Team Attendance" live under
// the ESS menu; the leave/attendance approval pages live under the "My Approvals" menu.)
export const LeaveAttnRoutes: IAppRoutes = {
  link: LEAVE_ATTN,
  childrens: [
    {
      // Apply leave on behalf of an employee — gated by the seeded ACL feature.
      link: LEAVE_FOR_EMPLOYEE,
      element: guard(() => import('@modules/leave-attn/leave-for-employee'), [LEAVE_FOR_EMPLOYEE]),
    },
    {
      // Apply manual attendance on behalf of an employee — gated by the seeded ACL feature.
      link: ATTENDANCE_FOR_EMPLOYEE,
      element: guard(() => import('@modules/leave-attn/attendance-for-employee'), [ATTENDANCE_FOR_EMPLOYEE]),
    },
    {
      // Company-wide monthly attendance register (HR/admin) — moved here from the "HR Only" menu.
      link: EMPLOYEE_ATTENDANCE,
      element: guard(() => import('@modules/leave-attn/employee-attendance'), [EMPLOYEE_ATTENDANCE]),
    },
    {
      // Company-wide leave register (HR/admin) — gated by the seeded ACL feature HRM_EMPLOYEE_LEAVE.
      link: EMPLOYEE_LEAVE,
      element: guard(() => import('@modules/leave-attn/employee-leave'), [EMPLOYEE_LEAVE]),
    },
    {
      // Claim compensatory off on behalf of an employee — gated by the seeded ACL feature.
      link: COMP_OFF_FOR_EMPLOYEE,
      element: guard(() => import('@modules/leave-attn/comp-off-for-employee'), [COMP_OFF_FOR_EMPLOYEE]),
    },
    {
      // Leave Type master (setup) — moved here from the Settings menu.
      link: LEAVE_TYPE,
      element: guard(() => import('@modules/leave-attn/leave-type'), [LEAVE_TYPE]),
    },
  ],
}
